<div class="dialog-container">
  <h2 class="dialog-title">Start Application</h2>
  
  <form [formGroup]="form" class="dialog-form">
    <mat-form-field [style.width.%]="100" appearance="outline">
      <mat-label>Select Branch</mat-label>
      <mat-select formControlName="branchId" [disabled]="isLoading">
        <mat-option *ngIf="isLoading" disabled>
          Loading branches...
        </mat-option>
        <mat-option *ngFor="let option of userBranchOptions" [value]="option.id">
          {{ option.name }}
        </mat-option>
        <mat-option *ngIf="!isLoading && userBranchOptions.length === 0" disabled>
          No branches available
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
  
  <div class="dialog-actions">
    <cm-button 
      color="primary"
      class="record-btn"
      [disabled]="isLoading || !form.valid"
      (click)="startApplication()">
      {{ isLoading ? 'Loading...' : 'Start Application' }}
    </cm-button>
    
    <cm-button 
      class="cancel-btn"
      [disabled]="isLoading"
      (click)="cancel()">
      Cancel
    </cm-button>
  </div>
</div>
